import styled from "styled-components";
import { Button } from "@findemdev/maui";

export const ActionButtons = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const RefreshButton = styled(Button)`
  min-width: 140px;
`;
